var AccountType = function (Properties) {
  Properties.ID ? this.ID = Properties.ID : this.ID = this.__proto__.ID;
  Properties.AccountTypeName ? this.AccountTypeName = Properties.AccountTypeName : this.AccountTypeName = this.__proto__.AccountTypeName;
  Properties.AccountTypeDescription ? this.AccountTypeDescription = Properties.AccountTypeDescription : this.AccountTypeDescription = this.__proto__.AccountTypeDescription;
  Properties.IsEditable ? this.IsEditable = Properties.IsEditable : this.IsEditable = this.__proto__.IsEditable;
  Properties.Type ? this.Type = Properties.Type : this.Type = this.__proto__.Type;
  Properties.CreationDateTime ? this.CreationDateTime = Properties.CreationDateTime : this.CreationDateTime = this.__proto__.CreationDateTime;
  Properties.CreatorId ? this.CreatorId = Properties.CreatorId : this.CreatorId = this.__proto__.CreatorId;
  Properties.Active ? this.Active = Properties.Active : this.Active = this.__proto__.Active;
  Properties.Deleted ? this.Deleted = Properties.Deleted : this.Deleted = this.__proto__.Deleted;
  Properties.Permissions ? this.Permissions = Properties.Permissions : this.Permissions = this.__proto__.Permissions;
  Properties.Users ? this.Users = Properties.Users : this.Users = this.__proto__.Users;
};

AccountType.prototype = {
  ID: null,
  AccountTypeName: '',
  AccountTypeDescription: '',
  IsEditable: true,
  Type: 5,
  CreationDateTime: null,
  CreatorId: null,
  Active: true,
  Deleted: false,
  Permissions: [],
  Users: [],
};
export default AccountType;
